<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Cron Logs
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 mt-10">
                <div class="form-group">
                  <label class="">Search By</label>
                  <select class="form-control pt-5 pb-5 pl-5 pr-5" v-model="searchBy">
                    <option value="" disabled selected>Select Search By</option>
                    <option v-for="(search, index) in searchByFilter" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2 mt-10">
                <div class="form-group">
                  <label class="">Name</label>
                  <input class="form-control pt-5 pb-5 pl-5 pr-5" type="text" v-model="name">
                </div>
              </div>
              <div class="col-md-4 pl-0 mt-23">
                <button class="btn btn-primary" v-on:click="fetchCronLogs" :disabled="loading">
                  Search
                </button>
                <button class="btn btn-pink ml-10" v-on:click="refreshLogs">
                  Clear All
                </button>
              </div>
            </div>
            <div class="loader" v-if="loading"></div>
            <div class="col-md-12 mt-10">
              <table id="datatable" class="table table-striped table-bordered">
                <thead class="light">
                <tr>
                  <th>Cron Name</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Started At</th>
                  <th class="text-center">Completed At</th>
                </tr>
                </thead>
                <tbody class="table-bordered">
                <tr v-for="(row, index) in cronLogs" :key="index">
                  <td>
                    {{ row.name }}
                    <small v-if="row.status === 'failed' && row.reasonForError" class="text-danger"><br><b>Re: {{ row.reasonForError || '' }}</b></small>
                  </td>
                  <td width="10%" class="text-center">
                    <span v-if="row.status === 'completed'">
                      <i class="fa fa-check-circle text-success fs-24" style="font-size:24px"></i>
                    </span><span v-else-if="row.status === 'running'">
                      <i class="fa fa-spinner fa-spin text-primary fs-24" style="font-size:24px"></i>
                    </span><span v-else-if="row.status === 'failed'">
                      <i class="fa fa-times-circle text-danger fs-24" style="font-size:24px"></i>
                    </span>
                  </td>
                  <td class="text-center">{{ parseDate(row.startedAt)}} </td>
                  <td class="text-center"><span v-if="row.completedAt">{{ parseDate(row.completedAt) }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import moment from 'moment'

export default {
  name: "CronLogs",
  data() {
    return {
      loading: false,
      cronLogs: [],
      searchByFilter: [{
        value: 'running',
        name: 'Running'
      },{
        value: 'failed',
        name: 'Failed'
      },{
        value: 'completed',
        name: 'Completed'
      }],
      searchBy: '',
      name: '',
      pageSize: 1000,
      pageNumber: 1,
      rowsPerPageValue: 10,
      rowsPerPage: [
        {key: 10, value: 10, selected: true},
        {key: 30, value: 30, selected: false},
        {key: 50, value: 50, selected: false},
      ],
    }
  },
  watch: {
    cronLogs() {
      this.renderDatatable()
    }
  },
  mounted() {
    this.fetchCronLogs()
  },
  computed:{
    last () {
      return (this.cronLogs.length > 0) ? this.cronLogs[this.cronLogs.length-1] : null;
    },
    first () {
      return (this.cronLogs.length > 0) ? this.cronLogs[0] : null;
    }
  },
  methods: {
    renderDatatable() {
      if($.fn.DataTable.isDataTable('#datatable')) {
        $(`#datatable`).DataTable().destroy();
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      setTimeout(function () {
        $(`#datatable`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo" : false,
          "ordering": false,
        });
      }, 1000)
    },
    parseDate(date) {
      return moment(date).format('DD MMM YYYY, hh:mm a')
    },
    async fetchCronLogs (action = null) {
      this.loading = true;
      let ref = db.collection('cronStatus');
      let docs = [];
      let query = null;
      try {
        if ((this.searchBy) ) {
          query =  ref
                .where('status', "==",  this.searchBy)
                .orderBy('startedAt', 'desc')
        } else if(this.name) {
          query =  ref
              .where('name', "==",  this.name)
              .orderBy('startedAt', 'desc')
        }  else {
          query = ref
              .orderBy('startedAt', 'desc');
        }
        if(this.pageNumber !== 1){
          if(action==='next'){
            docs = await query.startAfter(this.last.startedAt)
                .limit(this.pageSize)
                .get();
          }else
            docs = await query.endBefore(this.first.startedAt)
                .limitToLast(this.pageSize)
                .get();
        }
        else {
          docs = await query
              .limit(this.pageSize)
              .get();
        }
        this.cronLogs = []
        docs.forEach(el => {
          this.cronLogs.push({id: el.id, ...el.data()})
        });
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        this.loading = false;
      } catch (err) {
        console.error(err);
        this.loading = false;
        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {show: false});
        }, 5000);
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      this.loading = false;
    },
    async refreshLogs(){
      this.searchBy=null
      this.pageNumber = 1;
      await this.fetchCronLogs()
    },
    async nextPage() {
      this.pageNumber++;
      await this.fetchCronLogs('next')
    },
    async prevPage() {
      this.pageNumber--;
      await this.fetchCronLogs('prev')
    }
  }
}
</script>

<style scoped>

</style>
